import React, { FunctionComponent } from "react";

import CloseIcon from "@uui/XClose";

import { SvgIconProps, SxProps } from "@mui/material";

import type { Tag as ITag } from "@app/common/types";

import { TagAction, TagContainer, TagLabel } from "./styles";
import { getTagFontColorFromColor, isDarkTagColor } from "./utils";

export interface TagProps {
  startIcon?: FunctionComponent<SvgIconProps>;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onAction?: (tag: ITag) => void;
  actionIcon?: React.ReactNode;
  sx?: SxProps;
  tag: ITag;
  hidden?: boolean;
  sizing?: "padded" | "compact";
  noTitle?: boolean;
}

const Tag = ({
  onClick,
  onAction,
  actionIcon,
  sx,
  tag,
  hidden = false,
  sizing = "compact",
  startIcon,
  noTitle,
}: TagProps) => {
  const isAutoTag = tag.kind === "auto";
  const isDarkTag = isDarkTagColor(tag.color);

  const handleAction = (event: React.MouseEvent) => {
    event.stopPropagation();
    onAction?.(tag);
  };
  const Icon = startIcon;

  return (
    <TagContainer
      variant="left"
      hidden={hidden}
      sizing={sizing}
      onClick={onClick}
      sx={{
        ...sx,
        bgcolor: tag.color,
        color: getTagFontColorFromColor(tag.color),
        padding: Icon ? "4px" : undefined,
      }}
    >
      {Icon && (
        <Icon sx={{ width: "16px", height: "16px", marginRight: "6px" }} />
      )}
      <TagLabel title={noTitle ? undefined : tag.name}>
        {isAutoTag && "✨ "}
        {tag.name}
      </TagLabel>
      {onAction && (
        <TagAction kind={isDarkTag ? "dark" : "light"} onClick={handleAction}>
          {actionIcon ?? <CloseIcon />}
        </TagAction>
      )}
    </TagContainer>
  );
};

export default Tag;
